import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Hero, VehicleInformation } from "../motorcycles/MotorcycleView";
import { StaticContext } from "react-router";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { FastFacts as FactsComponent } from "./FastFact";
import { Link } from "react-router-dom";
import "./overview.scss";
import { Part } from "../../parts/PartsList";
import { connect } from "react-redux";
import {
	mapStateToProps,
	mapDispatchToProps,
	StateManagementProps
} from "../../../utils/addReduxProps";
import { Setup } from "../../setups/SetupsList";
import { Subtract, WithNamespaces, withNamespaces } from "react-i18next";
import store from "../../../redux/store";
import getOverview from '../../../redux/async-actions/getOverview';
import { exitVehicleConfiguration } from "../../../redux/actions";


type VehicleInformationWithoutHero = Subtract<
	VehicleInformation,
	{ Hero: Hero }
>;

export interface VehicleOverviewResponse {
	Vehicle: VehicleInformationWithoutHero;
	FastFacts: FastFact[];
	Parts: Part[];
	Setups: Setup[];
}

export interface FastFact {
	Text: string | null;
	ImageUrl: string | null;
}

export type OverviewAllProps = RouteComponentProps<{ modelId: string }, StaticContext, { hero: Hero }> &
	StateManagementProps &
	WithNamespaces;

export class Overview extends React.Component<OverviewAllProps> {
	constructor(props: OverviewAllProps) {
		super(props);
		this.resetAndGoToModels = this.resetAndGoToModels.bind(this);
	}

	componentDidMount() {
		if (!this.hasOverviewData()) {
			// @todo: better types when available
			store.dispatch(getOverview(this.props.match.params.modelId) as any)
		}
	}

	resetAndGoToModels() {
		store.dispatch(exitVehicleConfiguration());
		this.props.history.goBack();
	}

	render() {
		if (!this.hasOverviewData()) {
			return <CircularProgress className="spinner" />;
		}

		const { hero } = this.props.location.state;
		const {
			Vehicle: {
				Hero: { Description }
			},
			FastFacts
		} = this.props.overview;
		const { modelId } = this.props.match.params;
		const imageProps = {
			src: process.env.REACT_APP_SERVER_ROOT + hero.ImageUrl
		};
		const { t } = this.props;

		return (
			<Grid item id="bike-overview-main">
				<Grid
					className="full-height"
					container
					alignItems="center"
					justify="space-between"
					direction="column"
					spacing={0}
				>
					<Grid item id="back-to-selection-wrapper" className="full-width">
						<div onClick={this.resetAndGoToModels}>
							<p className="clickable">
								<span style={{ width: 5, display: "inline-block" }} />
								{hero.Intro}
							</p>
						</div>
					</Grid>
					<Grid item id="bike-overview-info-wrapper" className="full-width">
						<Grid container className="full-height">
							<Grid item xs={8} className="full-height">
								<Grid container
									justify="center"
									alignContent="center"
									className="full-height"
								>
									<img
										alt="overview"
										id="overview-main-image"
										{...imageProps}
									/>
								</Grid>
							</Grid>
							<Grid item xs={4} className="full-height">
								<Grid
									className="full-height"
									container
									direction="column"
									justify="center"
									alignContent="flex-start"
								>
									<h2 className="headline">{hero.Title}</h2>
									<p className="text overflow-auto max-height">{Description}</p>
									<div id="bike-overview-button-wrapper">
										{/* <button className="secondary">{t('buttons.testDrive')}</button> */}
										{/* @todo: REMOVE '/categores' from the next when setups become active */}
										<Link to={`/configuration/${modelId}/categories`}>
											<button className="primary">{t('buttons.configure')}</button>
										</Link>
									</div>{" "}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item id="fast-facts-wrapper" className="full-width">
						<FactsComponent facts={FastFacts} />
					</Grid>
				</Grid>
			</Grid>
		);
	}

	private hasOverviewData = () => (this.props.overview.Vehicle.ModelId.length);
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Overview));
